import React from "react";

const Divider = ({addClass, dotted}) => {
  return <div className={`divider ${addClass ?? ""}${dotted ? " dotted" : ""}`}></div>;
};

export default Divider;
